import { useEffect, useState } from "react";
import { Button, Grid, Modal } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import { PermitType } from "../models/PermitType";
import AddPermitTypeToRegisterForm, { FormData } from "./AddPermitTypeToRegisterForm";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (permitTypeIds: string[]) => void;
  submitInProgress: boolean;
  submitErrors?: string[];
  availablePermitTypes?: PermitType[];
}

const AddPermitTypeToRegisterModal = ({
  open,
  onClose,
  onSubmit,
  submitInProgress,
  submitErrors,
  availablePermitTypes,
}: Props) => {
  const [formData, setFormData] = useState<FormData>({ permitTypeIds: [] });
  const [formErrors, setFormErrors] = useState<FormError>({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    if (!open) {
      setFormData({ permitTypeIds: [] });
      setFormErrors({});
      setHasSubmitted(false);
    }
  }, [open]);

  const validateFormData = (data: FormData): FormError => {
    const errors: FormError = {};
    if (!data.permitTypeIds || data.permitTypeIds.length === 0) {
      errors.permitTypeIds = "Please select at least one permit type";
    }
    return errors;
  };

  const handleSubmit = () => {
    setHasSubmitted(true);
    const validationErrors = validateFormData(formData);
    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      onSubmit(formData.permitTypeIds);
    }
  };

  const handleFormChange = (data: FormData) => {
    if (hasSubmitted) {
      setFormErrors(validateFormData(data));
    }
    setFormData({ ...data });
  };

  return (
    <Modal open={open} size="small">
      <Modal.Header>Add permit type to register</Modal.Header>
      <Modal.Content style={{ padding: "0px" }}>
        <Grid divided style={{ margin: "0px" }}>
          <Grid.Column stretched width="16">
            <AddPermitTypeToRegisterForm
              formErrors={formErrors}
              errors={submitErrors}
              formData={formData}
              onChange={handleFormChange}
              availablePermitTypes={availablePermitTypes}
            />
          </Grid.Column>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} positive loading={submitInProgress} disabled={submitInProgress}>
          Add
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default AddPermitTypeToRegisterModal;

